define("command-palette/instance-initializers/register-commands", ["exports", "command-palette/utils/get-command-lookup"], function (_exports, _getCommandLookup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.initialize = initialize;
  0; //eaimeta@70e063a35619d71f0,"command-palette/utils/get-command-lookup"eaimeta@70e063a35619d71f

  function initialize(appInstance) {
    const commandRegistryService = appInstance.lookup('service:command-palette/private/command-registry'); // @ts-expect-error - TODO: the `application` object exists but isn't defined on the
    // type `ApplicationInstance`

    const {
      modulePrefix
    } = appInstance.application; // @ts-expect-error - TODO: Ember CLI has a `entries` mapping on `require` which isn't
    // a part of the regular `NodeRequire` type.

    const moduleEntries = Object.keys(require.entries);
    moduleEntries.filter(name => name.startsWith(`${modulePrefix}/commands/`)).forEach(moduleName => {
      // TODO: we may have to revisit usage of `require` as we progress through ember-cli versions
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const module = require(moduleName);

      if (module && module.default) {
        const ConcreteCommand = module.default;
        const commandLookup = (0, _getCommandLookup.getCommandLookup)(ConcreteCommand);
        const commandInstance = appInstance.lookup(commandLookup);
        commandRegistryService.register(ConcreteCommand.commandId, commandInstance);
      }
    });
  }

  var _default = {
    initialize
  };
  _exports.default = _default;
});